<template>
  <ReportWrapper
    :disable-download="!selectedDateRange"
    :is-downloading="isLoading"
    @download="downloadPdf"
  >
    <template #prepend>
      <CfsDateField v-model="selectedDateRange" placeholder="Date" range />
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFileByType } from '@/helpers/download';
import { DocumentTypes, OutputTypes } from '@/constants/reports';
import { useToast } from '@/composables/useToast';
import date, { DateFormat } from '@/extensions/filters/date';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'SummaryActivityReport',
  components: {
    ReportWrapper,
  },
  setup() {
    const toast = useToast();

    const selectedDateRange = ref<{ start: string; end: string } | null>(null);

    const { useDownloadInternalInventoryReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadInternalInventoryReport();

    const downloadPdf = async () => {
      if (!selectedDateRange.value) return toast.info('Please select date.');

      try {
        const { data } = await downloadReport({
          fromdate: selectedDateRange.value?.start,
          todate: selectedDateRange.value?.end,
          documentType: DocumentTypes.SUMMARY_ACTIVITY,
          outputType: OutputTypes.XLSX,
        });
        if (!data) return;
        const fromFormatted = dayjs.utc(selectedDateRange.value?.start).format(DateFormat.Default);
        const toFormatted = dayjs.utc(selectedDateRange.value?.end).format(DateFormat.Default);
        downloadFileByType(
          data,
          `Summary Activity Report  ${fromFormatted} - ${toFormatted}`,
          OutputTypes.XLSX
        );
      } catch (e) {
        console.log(e);
      }
    };

    return { selectedDateRange, isLoading, downloadPdf };
  },
});
</script>
